



































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import AddNotificationButton from '@/components/Admin/Layout/AddNotificationButton.vue';
import NotificationList from '@/components/Admin/Lists/NotificationList.vue';
import SelectedItems from '@/components/Admin/Layout/SelectedItems.vue';
import ConfirmPopup from '@/components/Admin/Panels/ConfirmPopup.vue';
import BroadcastFlyout from '@/components/Flyouts/BroadcastFlyout.vue';
import Recipients from '@/components/Admin/Panels/Recipients.vue';

@Component({
    components: {
        AddNotificationButton,
        NotificationList,
        SelectedItems,
        ConfirmPopup,
        BroadcastFlyout,
        Recipients,
    },
    computed: {
        ...mapGetters({
            formVisible: 'Viewport/isAddFormVisible',
            confirmPopupVisibility: 'ConfirmPopup/getConfirmPopupVisibility',
        }),
    },
})

export default class Notifications extends Vue {
    constructor() {
        super();
    }

    get hasSelectedProjects(): any {
        return this.$store.getters['Projects/selectedProjects'].length;
    }

    get hasSelectedBuildings(): any {
        return this.$store.getters['Buildings/selectedBuildings'].length;
    }

    get hasSelectedProperties(): any {
        return this.$store.getters['Properties/selectedProperties'].length;
    }

    get hasSelectedItem(): boolean {
        return this.hasSelectedProjects ||  this.hasSelectedBuildings || this.hasSelectedProperties;
    }

    get dataLoaded(): boolean {
        return this.$store.getters['Notifications/getAdminNotificationDataLoaded'];
    }

    get recipientsVisible(): boolean {
        return this.$store.getters['Recipients/getRecipientsVisible'];
    }

    get activeNotification(): any {
        return this.$store.getters['Notifications/getActiveNotification'];
    }

    get addMenuVisible() {
        return this.$store.getters['Viewport/menuVisible'];
    }

    get addMenuClass() {
        return {
            activeForm: this.addMenuVisible,
        };
    }

    get editNotificationMenuVisible() {
        return this.$store.getters['Notifications/editNotificationMenuVisible'];
    }

    get editNotificationMenuClass() {
        return {
            activeForm: this.editNotificationMenuVisible,
        };
    }

    get editNotificationFormVisible() {
        return this.$store.state.Notifications.editNotificationFormVisible;
    }

    public addNotification() {
        this.$store.dispatch(Actions.INITIATE_NOTIFICATION).then(() => {
            this.slideInForm('add-notification');
        });
    }

    public slideInForm(formKey: string) {
        this.$store.dispatch(Actions.SHOW_FORM, formKey);
    }

    public mounted() {
        if (typeof this.$route.params.notificationId !== 'undefined') {
            this.$store.commit(Mutations.UPDATE_ACTIVE_NOTIFICATION, Number(this.$route.params.notificationId));
            this.$store.commit(Mutations.EDIT_ACTIVE_NOTIFICATION);
            this.$store.commit(Mutations.SHOW_EDIT_NOTIFICATION_FORM, 'edit-notification');
        }
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ADMIN_NOTIFICATIONS);
    }
}
